import styled from "styled-components";

export const BannerOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }
`;

export const BannerText = styled.div`
  flex: 1;

  p {
    font-size: 14px;
    color: #333;
    margin: 0;
    line-height: 1.5;
  }

  a {
    color: #18216d;
    text-decoration: underline;
    font-weight: 600;

    &:hover {
      color: #2e186a;
    }
  }
`;

export const BannerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.25rem;

  span {
    font-family: "Motiva Sans Bold", sans-serif;
    font-size: 14px;
    color: #333;
  }
`;

export const BannerButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;

  @media only screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const OutlineButton = styled.button`
  background: transparent;
  color: #333;
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  padding: 0.5rem 1.25rem;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: #18216d;
    color: #18216d;
  }
`;

export const AcceptButton = styled.button`
  background: #18216d;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #2e186a;
  }
`;
